<template>
  <div>
    <div><h5>Failure Page</h5></div>
    <p class="title">Transaction Failed</p>
  </div>
</template>

<script>
export default {
  name: "Failure",
};
</script>

<style lang="scss" scoped>
.title {
  font-weight: bold;
  font-size: 15px;
  color: black;
}
</style>
